import React from 'react';
import './WhyUs.css';

import { images, whyChooseUs } from '../../../constants';
import { Heading } from '../../../components';



const WhyUs = () => {

  return (
    <section className="why-us linear-bg">

      {/* Section Heading */}
      <Heading title={whyChooseUs.heading} subTitle={whyChooseUs.sub} linear />

      {/* Content Container */}
      <div className="box-container">

        {/* First Column - First 3 Benefits */}
        <div className="box-1">
          {whyChooseUs.points.slice(0, 3).map((item) => (
            <div className="why-item" key={item.id}>
              <div className='icon'>{item.icon}</div>
              <h5>{item.title}</h5>
              <p>{item.content}</p>
            </div>
          ))}
        </div>

        {/* Center Image */}
        <div className="image">
          <img src={images.WhyUs} alt="Why Choose Us - Car Dealer" />
        </div>

        {/* Second Column - Remaining Benefits */}
        <div className="box-2">
          {whyChooseUs.points.slice(3).map((item) => (
            <div className="why-item" key={item.id}>
              <div className='icon'>{item.icon}</div>
              <h5>{item.title}</h5>
              <p>{item.content}</p>
            </div>
          ))}
        </div>

      </div>

    </section>
  );
};

export default WhyUs;